import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Validator that checks if an array is non-empty
 */
export function nonEmptyArrayValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value as unknown[];
  return Array.isArray(value) && value.length > 0 ? null : { required: true };
}

/**
 * Validator that checks if at least one item is selected in a form array
 */
export function atLeastOneSelectedValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (!Array.isArray(value)) return { atLeastOne: true };

  const hasSelected = value.some((item: any) => !!item);
  return hasSelected ? null : { atLeastOne: true };
}

/**
 * Error message utilities for form validation
 */
export class ValidationErrorMessages {
  static getErrorMessage(
    control: AbstractControl,
    fieldName: string,
    label?: string,
  ): string | null {
    if (!control.touched || control.valid) return null;

    if (control.hasError('required')) {
      return `${fieldName} is required`;
    }

    if (control.hasError('atLeastOne')) {
      return `${label || fieldName} needs at least one selected`;
    }

    return `${fieldName} is invalid`;
  }
}
